import React, { useState, useEffect } from 'react';
import { convertiDataComputer2Umano, convertiImportoComputer2Umano } from './funzioni.js'
import Carrello from "./Carrello.js"
import SelectGiorni from "./SelectGiorni";
import Clessidra from '../Pagine/Clessidra'
import stile from './stile.module.css';
import { haPersonalizzazione } from '../funzioni.js';

function Abbonamenti(props) {
    const PAGINE = {
        "caricamentoDati": 1,
        "elencoAbbonamenti": 2,
        "elencoAbbonamentiAcquistabili": 3,
        "confermaAttivazioneAbbonamento": 4,
        "confermaRinnovoAbbonamento": 5,
        "visualizzaCarrello": 6
    };
    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);
    const [elencoAbbonamenti, setElencoAbbonamenti] = useState([]);
    const [elencoAbbonamentiAcquistabili, setElencoAbbonamentiAcquistabili] = useState([]);
    const [unitaDurataAbb,setUnitaDurataAbb]=useState([]); // unità di misura della durata degli abbonamenti, non è quella delle rate
    const [abbonamentoSelezionato, setAbbonamentoSelezionato] = useState(0);
    const [dataInizio, setDataInizio] = useState("");

    function scaricaElencoAbbonamenti() {
        setPagina(PAGINE.caricamentoDati);
        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ op: "abbonatiRecuperaDati", "soloMiei": 1, emak: props.emak, sessionId: props.sessionId })
        };
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.verifvers === 0) {
                        // necessario aggiornare la app
                        props.callbackAggiornaApp();
                        return;
                    }
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) { 
                        window.alert("Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                        props.callback(props.PAGINECLIENTI.login);
                        return; 
                    }
                    setElencoAbbonamenti(valore_di_ritorno.risultatoRitorno);

                    if (props.identitaSelezionata.acq_app=="1") {
                        // può acquistare, quindi scarico l'elenco degli abbonamenti acquistabili
                        requestOptions = {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ op: "elencoAbbonamentiAcquistabili", emak: props.emak, sessionId: props.sessionId })
                        };
                        fetch(props.UrlBackend, requestOptions)
                            .then(risposta => risposta.json())
                            .then(
                                (valore_di_ritorno) => {
                                    if (valore_di_ritorno.verifvers === 0) {
                                        // necessario aggiornare la app
                                        props.callbackAggiornaApp();
                                        return;
                                    }
                                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
                                    if (valore_di_ritorno.risultatoOperazione !== 1) { 
                                        window.alert("Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                                        props.callback(props.PAGINECLIENTI.login);
                                        return; 
                                    }
                                    setElencoAbbonamentiAcquistabili(valore_di_ritorno.risultatoRitorno);  
                                    
                                    // ora scarico le unità di misura della durata
                                    requestOptions = {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({op:"elencoUnitaTempo",recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
                                    };
                                
                                    fetch(props.UrlBackend, requestOptions)
                                        .then(risposta => risposta.json())
                                        .then(
                                        (valoreDiRitorno) => {
                                            if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                                                window.alert("Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                                                props.callback(props.PAGINECLIENTI.login);
                                            }
                                            if(valoreDiRitorno.risultatoOperazione===2) props.callback(props.PAGINECLIENTI.login);
                                            if(valoreDiRitorno.risultatoOperazione===1){  
                                                var arrUnit = [];
                                                for (let j=0; j<valoreDiRitorno.risultatoRitorno.length ; j++) {
                                                    arrUnit[valoreDiRitorno.risultatoRitorno[j].ID] = valoreDiRitorno.risultatoRitorno[j].DESCRIZIONE_UNITA_TEMPO;
                                                }
                                                setUnitaDurataAbb(arrUnit);

                                                // fine delle ricerche dati, elenco gli abbonamenti acquistabili
                                                setPagina(PAGINE.elencoAbbonamenti);    
                                            }
                                        },
                                        (error) => {
                                            props.callback(props.PAGINECLIENTI.login);
                                            return;
                                        }
                                    );
                                                                    
                                },
                            (error) => {
                                props.callback(props.PAGINECLIENTI.login);
                                return;
                            }
                        );             
                    } else {
                        setPagina(PAGINE.elencoAbbonamenti);
                    }
                },
                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );                                 
    }

    function attivaAbbonamento() {
        setPagina(PAGINE.caricamentoDati);
        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ op: "inserisciAbbonatoDaIscritto", "idabbonamento":abbonamentoSelezionato.ID, dataInizio:dataInizio, emak:props.emak, sessionId:props.sessionId })
        };
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.verifvers === 0) {
                        // necessario aggiornare la app
                        props.callbackAggiornaApp();
                        return;
                    }
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) { 
                        window.alert("Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                        props.callback(props.PAGINECLIENTI.login);
                        return; 
                    }
                    setPagina(PAGINE.visualizzaCarrello);
                },
                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );                                 
    }

    function normalizza_nomi_unita(quantita, unita) {
        unita = unita.toLowerCase();
        if (quantita != 1) return unita;
        if (unita == "giorni") return "giorno";
        if (unita == "mesi") return "mese";
        if (unita == "anni") return "anno";
        return unita;
    }

    function analizzaDataOra(valore) {
        if (!valore) return null;

        /*
        * Formati accettati:
        * 2026-06-30
        * 2026-06-30 05:30
        * 2026-06-30 05:30:00
        * 2026-06-30T05:30
        * 2026-06-30T05:30:00
        */
        const match = String(valore).trim().match(
            /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::\d{2})?)?$/
        );

        if (!match) return null;

        return {
            anno: Number(match[1]),
            mese: Number(match[2]),
            giorno: Number(match[3]),
            ora: match[4] !== undefined ? match[4] : null,
            minuti: match[5] !== undefined ? match[5] : null,
            dataISO: `${match[1]}-${match[2]}-${match[3]}`,
            haOrario: match[4] !== undefined && match[5] !== undefined
        };
    }

    function formattaSoloData(data) {
        if (!data) return "";

        const giorniSettimana = [
            "dom", "lun", "mar", "mer", "gio", "ven", "sab"
        ];

        /*
        * Uso mezzogiorno per evitare eventuali anomalie legate
        * al cambio dell'ora.
        */
        const oggettoData = new Date(
            data.anno,
            data.mese - 1,
            data.giorno,
            12,
            0,
            0
        );

        const giornoSettimana = giorniSettimana[oggettoData.getDay()];

        return (
            giornoSettimana + " " +
            String(data.giorno).padStart(2, "0") + "/" +
            String(data.mese).padStart(2, "0") + "/" +
            data.anno
        );
    }

    function formattaSoloOra(data) {
        if (!data || !data.haOrario) return "";

        return `${data.ora}:${data.minuti}`;
    }

    function preparaDateAbbonamento(dataInizioRaw, dataFineRaw) {
        const dataInizio = analizzaDataOra(dataInizioRaw);
        const dataFine = analizzaDataOra(dataFineRaw);

        /*
        * Se arriva un formato inatteso, mantengo il vecchio comportamento.
        */
        if (!dataInizio || !dataFine) {
            return {
                primoRiquadro: `da ${convertiDataComputer2Umano(dataInizioRaw)}`,
                secondoRiquadro: `a ${convertiDataComputer2Umano(dataFineRaw)}`
            };
        }

        const stessoGiorno = dataInizio.dataISO === dataFine.dataISO;

        /*
        * Stesso giorno e presenza dell'orario:
        * primo riquadro = giorno
        * secondo riquadro = intervallo orario
        */
        if (
            stessoGiorno &&
            dataInizio.haOrario &&
            dataFine.haOrario
        ) {
            return {
                primoRiquadro: formattaSoloData(dataInizio),
                secondoRiquadro:
                    `${formattaSoloOra(dataInizio)} - ${formattaSoloOra(dataFine)}`
            };
        }

        /*
        * Giorni differenti:
        * aggiungo l'orario solo quando effettivamente presente.
        */
        return {
            primoRiquadro:
                `da ${formattaSoloData(dataInizio)}` +
                (dataInizio.haOrario ? ` ${formattaSoloOra(dataInizio)}` : ""),

            secondoRiquadro:
                `a ${formattaSoloData(dataFine)}` +
                (dataFine.haOrario ? ` ${formattaSoloOra(dataFine)}` : "")
        };
    }

    function abbonamentoAttivo(abbonamento) {
        const dataFine = analizzaDataOra(abbonamento?.DATA_FINE);

        if (!dataFine) return false;

        /*
        * Confronto solo la data, non l'eventuale ora di scadenza:
        * l'abbonamento resta attivo per tutta la giornata finale.
        */
        const fine = new Date(
            dataFine.anno,
            dataFine.mese - 1,
            dataFine.giorno
        );
        fine.setHours(0, 0, 0, 0);

        const oggi = new Date();
        oggi.setHours(0, 0, 0, 0);

        if (fine < oggi) return false;

        /*
        * ACCESSI_RESIDUI:
        * - valore >= 0: abbonamento a ingressi, deve averne almeno uno;
        * - valore < 0, null o assente: nessun limite a ingressi.
        */
        if (
            abbonamento.ACCESSI_RESIDUI !== null &&
            abbonamento.ACCESSI_RESIDUI !== undefined &&
            abbonamento.ACCESSI_RESIDUI !== ""
        ) {
            const ingressi = Number(abbonamento.ACCESSI_RESIDUI);

            if (Number.isFinite(ingressi) && ingressi >= 0) {
                return ingressi > 0;
            }
        }

        return true;
    }

    useEffect(() => {
        scaricaElencoAbbonamenti();
    }, [])
    
    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);
        } 
    }, [props.flagRichiestaBack])  

    if (pagina === PAGINE.caricamentoDati) {
        return (<Clessidra loading={true} />)
    }

    if (pagina === PAGINE.elencoAbbonamenti) {
        return (        
            <div style={{overflowY:'auto'}}>
                {props.identitaSelezionata.acq_app=="1" &&
                    <div style={{display:"flex", flexDirection:"row"}} className={stile.movimentiElencoContenitoreElemento}>
                        <div style={{flex:1}} className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex, stile.baSecondoBottone].join(" ")} onClick={() => {setPagina(PAGINE.elencoAbbonamentiAcquistabili);}}>Acquista Nuovo Abbonamento</div>
                    </div>
                }
    
                {elencoAbbonamenti.length > 0 ? (
                    <div>    
                       {elencoAbbonamenti.map((x, i) => {
                            const dateVisualizzate = preparaDateAbbonamento(
                                x.DATA_INIZIO,
                                x.DATA_FINE
                            );

                            const attivo = abbonamentoAttivo(x);

                            return (
                                <div
                                    key={i}
                                    className={[
                                        stile.movimentiElencoContenitoreElemento,
                                        attivo ? stile.movimentiAbbonamentoAttivo : stile.movimentiAbbonamentoNonAttivo
                                    ].join(" ")}
                                >
                                    <div style={{display: "flex", flexDirection: "row"}}>
                                        <div style={{flex: 1, paddingRight: 4}}>
                                            <div className={stile.movimentiTestoData}>
                                                {dateVisualizzate.primoRiquadro}
                                            </div>
                                        </div>

                                        <div style={{flex: 1, paddingLeft: 4}}>
                                            <div className={stile.movimentiTestoData}>
                                                {dateVisualizzate.secondoRiquadro}
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{paddingTop: 5}}>
                                        {/* per Well&Fit indica la classe di abbonamento e non il nome dell'abbonamento */}
                                        <div className={stile.movimentiTestoOperazioneBold}>
                                            {props.identitaSelezionata.nome_database=="EMA48" ? 
                                                x.CLASSE_ABBONAMENTO=="Abbonamento Annuale" ? "Quota di iscrizione" : "Abbonamento" 
                                            : 
                                                x.NOMEABBONAMENTO}
                                        </div>
                                    </div>
                                    {x.ACCESSI_RESIDUI >= 0 && 
                                        <div style={{paddingTop: 5}}>
                                            <div className={stile.movimentiTestoOperazione}>
                                                {x.ACCESSI_RESIDUI == 1 ? "Resta ":"Restano "}
                                                {parseFloat(x.ACCESSI_RESIDUI).toLocaleString("it-IT")}
                                                {haPersonalizzazione(props.identitaSelezionata, "guapacha") ?
                                                    x.ACCESSI_RESIDUI == 1 ? " ora disponibile":" ore disponibili"
                                                :
                                                    x.ACCESSI_RESIDUI == 1 ? " ingresso disponibile":" ingressi disponibili"
                                                }
                                            </div>
                                        </div>
                                    }

                                    {props.identitaSelezionata.acq_app=="1" && (() => {
                                        const s = x?.DATA_FINE || "";
                                        if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;

                                        const parts = s.split("-").map(Number);
                                        const dt = new Date(parts[0], parts[1] - 1, parts[2]); // data locale a mezzanotte

                                        const today = new Date();
                                        today.setHours(0, 0, 0, 0);

                                        const limit = new Date(today);
                                        limit.setDate(limit.getDate() + 14);

                                        return dt >= today && dt <= limit;
                                        })() &&
                                        <div style={{display:"flex", flexDirection:"row"}} className={stile.movimentiElencoContenitoreElemento}>
                                            <div 
                                                style={{flex:1}} className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex, stile.baSecondoBottone].join(" ")} 
                                                onClick={() => {
                                                    // potrebbe avere più abbonamenti di questo tipo, cioè con lo stesso idabbonamento e fatti in date diverse,
                                                    // e non aver cliccato Rinnova sull'ultimo -> devo trovare la massima data di fine degli abb di questo tipo
                                                    var idabbonamento = x.IDABBONAMENTO;
                                                    var dataFine = x.DATA_FINE;
                                                    for (var k=0; k<elencoAbbonamenti.length; k++) {
                                                        if (elencoAbbonamenti[k].IDABBONAMENTO == idabbonamento) {
                                                            if (elencoAbbonamenti[k].DATA_FINE > dataFine) dataFine = elencoAbbonamenti[k].DATA_FINE;
                                                        }
                                                    }
                                                    // calcolo la nuova data di inizio, che è dataFine più un giorno
                                                    const [y, m, d] = dataFine.split("-").map(Number);
                                                    const dt = new Date(Date.UTC(y, m - 1, d));
                                                    dt.setUTCDate(dt.getUTCDate() + 1);
                                                    const yy = dt.getUTCFullYear();
                                                    const mm = String(dt.getUTCMonth() + 1).padStart(2, "0");
                                                    const dd = String(dt.getUTCDate()).padStart(2, "0");
                                                    setDataInizio(yy+"-"+mm+"-"+dd);
                                                    var trovato = false;
                                                    for (var i=0; i<elencoAbbonamentiAcquistabili.length; i++) {
                                                        if (elencoAbbonamentiAcquistabili[i].ID == x.IDABBONAMENTO) {
                                                            trovato = true;
                                                            setAbbonamentoSelezionato(elencoAbbonamentiAcquistabili[i]);
                                                        }
                                                    }
                                                    if (trovato) setPagina(PAGINE.confermaRinnovoAbbonamento);
                                                    else setPagina(PAGINE.elencoAbbonamenti);
                                                }}
                                            >
                                                Rinnova Abbonamento
                                            </div>
                                        </div>
                                    }

                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div style={{color:"#FFFFFF", padding:10, textAlign:'center'}}>Non hai ancora nessun abbonamento</div>
                )}
            </div>
        );
    }    

        if (pagina === PAGINE.elencoAbbonamentiAcquistabili) {
        return (        
            <div style={{overflowY:'auto', textAlign:'center'}}>
                
                <div style={{marginTop:5, marginBottom: 5, color:"#FFFFFF"}}>Clicca sull'abbonamento che desideri attivare</div>
    
                {elencoAbbonamentiAcquistabili.length > 0 ? (
                    <div>    
                        {elencoAbbonamentiAcquistabili.map((x, i) => 
                            <div key={i} className={stile.movimentiElencoContenitoreElemento}>
                                <div style={{textAlign: 'center', paddingTop: 5}} onClick={() => {setAbbonamentoSelezionato(x); setPagina(PAGINE.confermaAttivazioneAbbonamento)}}>
                                    <div className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex, stile.baSecondoBottone].join(" ")}><b>{x.NOME}</b></div>
                                </div>
                                <div style={{display: 'flex', flexDirection: 'row', marginTop:5}}>
                                    <div style={{flex: 1, justifyContent: 'center', paddingLeft: 2}}>
                                        <div>
                                            <b>Durata:</b> {x.DURATA_PREDEFINITA} {normalizza_nomi_unita(x.DURATA_PREDEFINITA, unitaDurataAbb[x.DURATA_PREDEFINITA_UNITA_MISURA])}
                                        </div>
                                    </div>
                                    <div style={{flex: 1, justifyContent: 'center', paddingLeft: 2}}>
                                        <div>
                                            <b>Importo 
                                            {(x?.JSON_RATE.trim() != '' && x?.JSON_RATE.trim() != '[]') && " totale"}
                                            </b>: {convertiImportoComputer2Umano(x.IMPORTO)+" €"}
                                            
                                        </div>
                                    </div>
                                </div>
                                

                                {(() => {
                                    const raw = x?.JSON_RATE;
                                    if (!raw || (typeof raw === 'string' && (raw.trim() === '' || raw.trim() === '[]'))) return null;

                                    let rate;
                                    if (Array.isArray(raw)) rate = raw;
                                    else { try { rate = JSON.parse(raw); } catch { rate = []; } }
                                    if (!Array.isArray(rate) || rate.length === 0) return null;

                                    const fmtGGMM = (s) => {
                                        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
                                        return m ? `${m[3]}/${m[2]}` : s; // gg/mm (ogni anno)
                                    };

                                    // --- Parser importi → cent (gestisce "1.234,56", "1234.56", "€ 1.234,56", ecc.)
                                    const toCents = (v) => {
                                        if (v === null || v === undefined || v === '') return 0;
                                        if (typeof v === 'number') return Math.round(v * 100);
                                        let s = String(v).trim().replace(/[^\d.,-]/g, ''); // tiene solo cifre, separatori e segno

                                        const lastComma = s.lastIndexOf(',');
                                        const lastDot = s.lastIndexOf('.');
                                        let decimalSep = null, thousandsSep = null;

                                        if (lastComma !== -1 && lastDot !== -1) {
                                        decimalSep = lastComma > lastDot ? ',' : '.';
                                        thousandsSep = decimalSep === ',' ? '.' : ',';
                                        } else if (lastComma !== -1) {
                                        decimalSep = (s.length - lastComma - 1 === 2) ? ',' : null;
                                        } else if (lastDot !== -1) {
                                        decimalSep = (s.length - lastDot - 1 === 2) ? '.' : null;
                                        }

                                        if (thousandsSep) s = s.replace(new RegExp(`\\${thousandsSep}`, 'g'), '');
                                        if (decimalSep && decimalSep !== '.') {
                                        const i = s.lastIndexOf(decimalSep);
                                        s = s.slice(0, i) + '.' + s.slice(i + 1);
                                        } else if (!decimalSep) {
                                        s = s.replace(/[.,]/g, '');
                                        }

                                        const n = parseFloat(s);
                                        return Number.isFinite(n) ? Math.round(n * 100) : 0;
                                    };
                                    // ---

                                    const totaleRateCents = rate.reduce((sum, r) => sum + toCents(r.importo), 0);
                                    const importoCents = toCents(x?.IMPORTO);
                                    const pagamentoImmediato = (importoCents - totaleRateCents) / 100;

                                    return (
                                        <div>
                                        <strong>Rate:</strong>
                                        <div>
                                            Pagamento immediato: {convertiImportoComputer2Umano(pagamentoImmediato)} €
                                        </div>

                                        {rate.map((r, idx) => (
                                            <div key={idx}>
                                            {r.unita === 'data'
                                                ? <>il {fmtGGMM(r.data)}: {convertiImportoComputer2Umano(r.importo)} €</>
                                                : <>{r.intervallo} {normalizza_nomi_unita(r.intervallo, r.unita)} dall'inizio abbonamento: {convertiImportoComputer2Umano(r.importo)} €</>
                                            }
                                            </div>
                                        ))}
                                        </div>
                                    );
                                    })()}

                            </div>
                        )}
                    </div>
                ) : (
                    <div style={{color:"#FFFFFF", padding:10, textAlign:'center'}}>Non ci sono abbonamenti acquistabili</div>
                )}

                <div style={{ display: "flex", justifyContent: "center", padding:10 }}>
                    <div 
                        className={[stile.baRossoSoft, stile.baNormale].join(" ")} 
                        onClick={() => { 
                            setPagina(PAGINE.elencoAbbonamenti)
                        }}
                    >
                        <div className={stile.spazioIconaPiccola}>
                            <img className={stile.iconaPiccolaQuadrata} src={require('./annullabianco.png')} />
                        </div>
                        Annulla
                    </div>

                    <div className={[stile.baNormale, stile.baFlex].join(" ")} >
                    </div>

                </div>

            </div>
        );
    }    

    if (pagina === PAGINE.confermaAttivazioneAbbonamento || pagina === PAGINE.confermaRinnovoAbbonamento) {
        return (        
            <div style={{overflowY:'auto', textAlign:'center'}}>                
                <div className={stile.movimentiElencoContenitoreElemento}>
                    {pagina === PAGINE.confermaAttivazioneAbbonamento && <>Conferma l'attivazione dell'abbonamento:</>}
                    {pagina === PAGINE.confermaRinnovoAbbonamento && <>Conferma il rinnovo dell'abbonamento:</>}
                    <div style={{textAlign: 'center', paddingTop:5, marginTop:5, paddingBottom:5, marginBottom:5, backgroundColor:"#FFFFFF"}}>
                        <div style={{fontSize:18}}><b>{abbonamentoSelezionato.NOME}</b></div>
                        <div style={{display: 'flex', flexDirection: 'row', marginTop:5, marginBottom:5, backgroundColor:"#FFFFFF"}}>
                            <div style={{flex: 1, justifyContent: 'center', paddingLeft: 2}}>
                                <div>
                                    <b>Durata:</b> {abbonamentoSelezionato.DURATA_PREDEFINITA} {normalizza_nomi_unita(abbonamentoSelezionato.DURATA_PREDEFINITA, unitaDurataAbb[abbonamentoSelezionato.DURATA_PREDEFINITA_UNITA_MISURA])}
                                </div>
                            </div>
                            <div style={{flex: 1, justifyContent: 'center', paddingLeft: 2}}>
                                <div>
                                    <b>Importo</b>: {convertiImportoComputer2Umano(abbonamentoSelezionato.IMPORTO)+" €"}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{marginBottom:5}}>a partire da:
                        {pagina === PAGINE.confermaAttivazioneAbbonamento && <div style={{textAlign: 'center', paddingTop:5, marginTop:5, paddingBottom:5, marginBottom:5}}>
                            <SelectGiorni id="giorni" onChange={setDataInizio}/>
                        </div>}
                        {pagina === PAGINE.confermaRinnovoAbbonamento && <> {convertiDataComputer2Umano(dataInizio)}</>
                        }
                    </div>

                    <div style={{ display: "flex", justifyContent: "center" }}>
                            
                        <div 
                            className={[stile.baRossoSoft, stile.baNormale].join(" ")} 
                            onClick={() => { 
                                if (pagina === PAGINE.confermaRinnovoAbbonamento) setPagina(PAGINE.elencoAbbonamenti); else setPagina(PAGINE.elencoAbbonamentiAcquistabili);
                            }}
                        >
                            <div className={stile.spazioIconaPiccola}>
                                <img className={stile.iconaPiccolaQuadrata} src={require('./annullabianco.png')} />
                            </div>
                            Annulla
                        </div>
    
                        <div className={[stile.baVerdeSoft, stile.baNormale, stile.baFlex, stile.baSecondoBottone].join(" ")} 
                            onClick={() => {
                                attivaAbbonamento();
                            }}>
                            <div className={stile.spazioIconaPiccola}>
                                <img className={stile.iconaPiccolaQuadrata} src={require('./okbianco.png')} />
                            </div>
                            Conferma
                        </div>
                                             
                    </div>                    

                </div>
            </div>
        )
    }

    if (pagina === PAGINE.visualizzaCarrello) {
        return (
            <Carrello {...props} pagaSubito callback={() => setPagina(PAGINE.elencoAbbonamenti)}/>
        )
    }

    return (
        <div>Errore pagina non trovata (Abbonamenti)</div>
    )
}

export default Abbonamenti;
